const CHAR_WIDTH = 9;
const HORIZONTAL_PADDING = 20;
const MIN_WIDTH = 46;
const BODY_HEIGHT = 30;
const ARROW_HEIGHT = 10;
const TOTAL_HEIGHT = BODY_HEIGHT + ARROW_HEIGHT;
const ARROW_HALF_WIDTH = 7.5;
const RADIUS = BODY_HEIGHT / 2;
// El contador no sigue el color de marca del sitio: es el mismo en todos, a
// diferencia del hover del pin de precio.
const FILL = '#5E5E5E';
const TEXT_COLOR = '#FDFEFF';

export const getClusterIconSize = count => {
  const text = String(count);
  const width = Math.max(
    MIN_WIDTH,
    text.length * CHAR_WIDTH + HORIZONTAL_PADDING
  );
  return { width, height: TOTAL_HEIGHT };
};

// Contorno continuo (cuerpo pill + flecha) en un solo path, mismo criterio
// que MapPriceIcon: sin costura entre el cuerpo y la punta.
const buildCounterPath = width => {
  const cx = width / 2;
  const arrowLeftX = cx - ARROW_HALF_WIDTH;
  const arrowRightX = cx + ARROW_HALF_WIDTH;

  return [
    `M ${RADIUS},0`,
    `L ${width - RADIUS},0`,
    `A ${RADIUS},${RADIUS} 0 0 1 ${width},${RADIUS}`,
    `L ${width},${BODY_HEIGHT - RADIUS}`,
    `A ${RADIUS},${RADIUS} 0 0 1 ${width - RADIUS},${BODY_HEIGHT}`,
    `L ${arrowRightX},${BODY_HEIGHT}`,
    `L ${cx},${TOTAL_HEIGHT}`,
    `L ${arrowLeftX},${BODY_HEIGHT}`,
    `L ${RADIUS},${BODY_HEIGHT}`,
    `A ${RADIUS},${RADIUS} 0 0 1 0,${BODY_HEIGHT - RADIUS}`,
    `L 0,${RADIUS}`,
    `A ${RADIUS},${RADIUS} 0 0 1 ${RADIUS},0`,
    'Z',
  ].join(' ');
};

const MapQuadrantIcon = ({ count }) => {
  const text = String(count);
  const { width } = getClusterIconSize(text);

  return `
    <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${TOTAL_HEIGHT}">
      <path d="${buildCounterPath(width)}" fill="${FILL}" />

      <text
        x="${width / 2}"
        y="${BODY_HEIGHT / 2}"
        font-size="14"
        font-weight="bold"
        fill="${TEXT_COLOR}"
        text-anchor="middle"
        dominant-baseline="middle"
        font-family="Open Sans, sans-serif"
      >
        ${text}
      </text>
    </svg>
  `;
};

export default MapQuadrantIcon;
